import { SideBarDef } from 'ag-grid-community';
import { agGridAmpDarkTheme, agGridBaseTheme } from 'Core-utils/agGridTheme';

export const customTheme = agGridBaseTheme;

export const findingsTheme = agGridAmpDarkTheme;

export const COLUMN_STATE_STORAGE_KEYS = {
  server: 'customActionExecutionsGridColumnState',
} as const;

export const COLUMN_MIN_WIDTHS = {
  EXTRA_LONG_TEXT: 800,
  LONG_TEXT: 600,
  MEDIUM_TEXT: 400,
  SHORT_TEXT: 200,
  MINI_TEXT: 125,
};

export const DEFAULT_COL_DEF = {
  minWidth: 50,
  resizable: true,
  sortable: false,
  filter: false,
  floatingFilter: false,
  suppressHeaderContextMenu: true,
  suppressHeaderMenuButton: true,
  wrapHeaderText: true,
  autoHeaderHeight: true,
};

export const GRID_CONFIG = {
  rowHeight: 40,
  headerHeight: 40,
  cacheBlockSize: 25,
  defaultHeight: '37.5rem',
  minHeight: '25rem',
  paginationPageSize: 50,
  sideBar: {
    toolPanels: [
      {
        id: 'columns',
        labelDefault: 'Columns',
        labelKey: 'columns',
        iconKey: 'columns',
        toolPanel: 'agColumnsToolPanel',
        toolPanelParams: {
          suppressPivots: true,
          suppressPivotMode: true,
          suppressRowGroups: true,
          suppressValues: true,
        },
      },
    ],
    hiddenByDefault: false,
    position: 'left',
  } as unknown as SideBarDef,
} as const;

export interface AgGridCustomActionExecutionsProps {
  actionSpecId: string;
  /** Base header label, e.g. `Action execution history: Ping webhook.site`. */
  title?: string;
  tableBodyHeight?: string;
  periodDays?: number;
};

/** Default visible columns aligned with engagement logs drill-down patterns. */
export const DEFAULT_COLUMN_STATE = [
  { colId: 'executionTime', width: null, hide: false, pinned: null, sort: null, flex: 0.5 },
  { colId: 'status', width: null, hide: false, pinned: null, sort: null, flex: 0.5 },
  { colId: 'flowSpecDisplayValue', width: null, hide: false, pinned: null, sort: null, flex: 0.5 },
  { colId: 'userDisplayValue', width: null, hide: false, pinned: null, sort: null, flex: 0.5 },
  { colId: 'executionDuration', width: null, hide: false, pinned: null, sort: null, flex: 0.5 },
  { colId: 'input', width: null, hide: false, pinned: null, sort: null, flex: 1.5 },
  { colId: 'output', width: null, hide: false, pinned: null, sort: null, flex: 1.5 },
  { colId: 'flowStateId', width: null, hide: true, pinned: null, sort: null, flex: 0.5 },
];
